"use strict";

export default class Draggable {
    constructor (options) {
        this.options = options;

        this._addEventListeners();
    }

    /**
     * Добавление обработчиков событий
     */
    _addEventListeners () {
        let defaults = {
            onDragStart: null,
            onDragEnter: null,
            onDragLeave: null,
            onDragOver:  null,
            onDragEnd:   null,
            onDrop:      null
        };

        this.containers = document.querySelectorAll(".draggable");
        this.draggable  = document.querySelectorAll(".drag_drop");

        this.containers.forEach(container => {
            container.options = this._extend(defaults, this.options);
        });

        this.draggable.forEach(element => {
            element.removeEventListener("dragenter", this.dragEnter);
            element.removeEventListener("dragleave", this.dragLeave);
            element.removeEventListener("dragover",  this.dragOver);
            element.removeEventListener("drop",      this.drop);


            element.addEventListener("dragenter", this.dragEnter);
            element.addEventListener("dragleave", this.dragLeave);
            element.addEventListener("dragover",  this.dragOver);
            element.addEventListener("drop",      this.drop);
        });

        this.containers.forEach(container => {
            container.removeEventListener("dragstart",  this.dragStart);
            container.removeEventListener("dragend",    this.dragEnd);

            container.addEventListener("dragstart",  this.dragStart);
            container.addEventListener("dragend",    this.dragEnd);
        });
    }

    /**
     * Объединение объектов
     *
     * @param {Boolean} deep     Глубокое объединение
     * @param {object}  extended Первый объединяемый объект
     * @param {object}  obj      Второй объединяемый объект
     *
     * @returns {object}
     */
    _extend () {
        const length = arguments.length;

        let extended = {};
        let deep     = false;
        let i        = 0;

        // Проверка наличия опции глубокого объединения
        if (Object.prototype.toString.call( arguments[0] ) === "[object Boolean]") {
            deep = arguments[0];
            i++;
        }

        const parent = this;

        // Объединение объектов
        let merge = function (obj) {
            for (let prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    // Если глубокое объединение и параметр объект, объединяем свойства
                    if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
                        extended[prop] = parent._extend( true, extended[prop], obj[prop] );
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        // Прохождение по обоим объектам и выполнение объединения
        for (; i < length; i++) {
            const obj = arguments[i];

            merge(obj);
        }

        return extended;
    }

    dragStart () {
        setTimeout(() => {
            this.classList.add("drag_start");

            const dropAreas = document.getElementsByClassName("drop");

            for (let i = 0; i < dropAreas.length; i++) {
                console.log(dropAreas[i], dropAreas[i].classList);
                dropAreas[i].classList.add("visible");
            }
        }, 10);
    }

    dragEnter (evt) {
        evt.preventDefault();

        this.classList.add("drag_enter");

        const container = document.querySelector(".draggable.drag_start");

        if (container && container.options.onDragEnter) { container.options.onDragEnter(container, this); }
    }

    dragOver (evt) { evt.preventDefault(); }

    dragLeave () {
        this.classList.remove("drag_enter");
        this.classList.remove("denied");
    }

    dragEnd () {
        this.classList.remove("drag_start");

        const dropAreas = document.getElementsByClassName("drop");

        for (let i = 0; i < dropAreas.length; i++) {
            dropAreas[i].classList.remove("visible");
        }
    }

    drop (evt) {
        this.classList.remove("drag_enter");
        this.classList.remove("denied");

        const container = document.querySelector(".draggable.drag_start");

        if (container.options.onDrop) { container.options.onDrop(container, this, evt); }
    }

    static init(options) { return new this(options); }
}

//document.addEventListener("load", Draggable.init());
